'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageHeader = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PageHeader, _React$Component);

  function PageHeader() {
    (0, _classCallCheck3.default)(this, PageHeader);
    return (0, _possibleConstructorReturn3.default)(this, (PageHeader.__proto__ || (0, _getPrototypeOf2.default)(PageHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(PageHeader, [{
    key: 'render',
    value: function render() {
      var styles = require('./PageHeader.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.PageHeader, style: { backgroundImage: 'url(' + this.props.backgroundImage + ')' } },
        _react2.default.createElement(_components.SiteHeaderGap, null),
        _react2.default.createElement(
          'div',
          { className: styles.PageHeader__inner },
          _react2.default.createElement(
            'h1',
            { className: styles['PageHeader__title'] },
            this.props.title
          )
        )
      );
    }
  }]);
  return PageHeader;
}(_react2.default.Component), _class.propTypes = {
  title: _react2.default.PropTypes.string.isRequired
}, _temp);
exports.default = PageHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/PageHeader.jsx
// module id = 2381
// module chunks = 0